// extracted by mini-css-extract-plugin
module.exports = {"text":"SDj4fjBJeAydtIvZOJm-d"};